import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export const specificUserQueryKey = 'specific-user';

export function useSpecificUserInfo(userId: string) {
    return useQuery({
        queryKey: [specificUserQueryKey, userId],
        queryFn: () => sdClient.getUser({ userId }),
    });
}
